import { mapState, mapGetters, mapActions } from 'vuex'

export const adminRegistrationComputed = {
  ...mapState('adminRegistration', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('adminRegistration', ['getStatus', 'getError']),
}

export const adminRegistrationMethods = mapActions('adminRegistration', [
  'registrationAdmin',
  'resetRegistrationAdmin',
])
